// extracted by mini-css-extract-plugin
module.exports = {"span":"styles_span__09sRP","success":"styles_success__FU6Bb","error":"styles_error__yedtK","warning":"styles_warning__casJO"};